import { Subject } from 'rxjs/Subject';
import { QueueServiceApi } from './../../shared/sdk/services/custom/QueueService';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// import * as io from 'socket.io-client';
import { Storage } from '@ionic/storage';
import { SFGOAuthService } from '../sfgoauth.service/sfgoauth.service';
// import { Observable, Subscription } from 'rxjs';
import { Subscription } from 'rxjs';
// import { QueueServiceProvider } from '../../shared/nestjs/payroll/queue-service/queueService-provider';
import { GDAuthInterface } from '../../model/gd-auth';

@Injectable()
export class SocketIoClientProvider {

  socket: any;
  socketHost: any;
  queueList: Array<any> = [];
  queueSubject: Subject<any> = new Subject();
  queuePayroll: Subject<any> = new Subject();
  baloonSubject: Subject<any> = new Subject();
  subscriptions: Array<Subscription> = [];
  countCurrent: number = 0;
  tempCountCurrent: number = 0;
  processingPayrollTmp: any;
  SFGoAuth: GDAuthInterface;

  constructor(public http: HttpClient,
    public sfGoAuthService: SFGOAuthService,
    public storage: Storage,
    public queueServiceApi: QueueServiceApi,
    // private queueServiceProvider: QueueServiceProvider
  ) {
    this.getGoPath();
  }

  getGoPath(): Promise<any> {
    return new Promise(async (resolve) => {
      if (!this.socket) {
        // this.SFGoAuth = await this.sfGoAuthService.getAuthorization();
        // if (this.SFGoAuth) {

        //   if (this.SFGoAuth.socket) {

        //     let socketHost = 'https://socket.dataon.com';
        //     if (this.SFGoAuth.socket.socketUrl != '' && this.SFGoAuth.socket.socketUrl != null && this.SFGoAuth.socket.socketUrl != undefined) {
        //       socketHost = `${this.SFGoAuth.socket.socketUrl}`
        //     }

        //     // this.socket = this.getInstance(socketHost)
        //     this.socket = io(socketHost, {
        //       path: this.SFGoAuth.socket.socketPath,
        //       transports: ['websocket'],
        //       autoConnect: true,
        //       reconnection: true,
        //       reconnectionDelay: 500
        //     });

        //     this.socket.on('connect_error', () => {
        //       // ;
        //       if (this.socket.disconnected) {
        //         this.socket.io.open();
        //       }
        //     })

        //     this.socket.on('disconnect', () => {
        //       if (this.socket.disconnected) {
        //         this.socket.io.open();
        //       }
        //     });

        //     this.socket.on('reconnect_error', () => {
        //       if (this.socket.disconnected) {
        //         this.socket.io.open();
        //       }
        //     });
        //   }
        // }
        resolve(true);
      } else {
        resolve(true);
      }
    })
  }

  timerOnPayroll() {
    // this.subscriptions.forEach(subscription => subscription.unsubscribe());
    // this.subscriptions.push(
    //     Observable
    //         .interval(1000)
    //         .subscribe(() => {
    //           if (this.countCurrent == this.tempCountCurrent) {
    //             this.subscriptions.push(
    //                 this.queueServiceProvider.progress()
    //                     .subscribe(res => {
    //                       try {
    //                         const data = SocketIoClientProvider.createResData(res);
    //                         if (res.tax.current && (res.tax.current < res.tax.total)) {
    //                           this.queueList = data;
    //                           this.queueSubject.next(this.queueList)
    //                           if (data[0].tracks.length > this.countCurrent) {
    //                             this.countCurrent = data[0].tracks.length;
    //                             this.tempCountCurrent = this.countCurrent;
    //                             if (this.countCurrent >= this.queueList[0].totalProcess) {
    //                               this.subscriptions.forEach(subscription => subscription.unsubscribe());
    //                               this.baloonSubject.next(false)
    //                             }
    //                           }
    //                         } else {
    //                           this.queueList = data;
    //                           this.queueSubject.next(this.queueList)
    //                           this.subscriptions.forEach(subscription => subscription.unsubscribe());
    //                           this.baloonSubject.next(false)
    //                         }
    //                       } catch (error) {
    //                       }
    //                     }, () => {
    //                       this.subscriptions.forEach(subscription => subscription.unsubscribe());
    //                       this.baloonSubject.next(false)
    //                     })
    //             )
    //           } else {
    //             this.tempCountCurrent = this.countCurrent;
    //           }
    //         })
    // )
  }

  // private static createResData(res: any) {
    // return [{
    //   code: res.tax.periodCode,
    //   payDate: res.tax.payDate,
    //   empId: res.empId,
    //   userId: res.userId,
    //   totalProcess: res.tax.total,
    //   tracks: res.tax.current ? new Array(res.tax.current) : []
    // }];
  // }

  timerOff() {
    // this.baloonSubject.next(false);
    // this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  getInstance(socketHost) {
    // return io(socketHost, {
    //   transports: ['websocket'],
    //   autoConnect: true,
    //   reconnection: true,
    //   reconnectionDelay: 500
    // });
  }

  of(namespace: string) {
    // this.socket.off(namespace);
  }

  on(eventName: string, callback: Function) {
    // if (this.socket) {
    //   this.socket.on(eventName, callback);
    // }
  }

  once(eventName: string, callback: Function) {
    // this.socket.once(eventName, callback);
  }

  connect() {
    // return this.socket.connect();
  }

  disconnect(close?: any) {
    // return this.socket.disconnect.apply(this.socket, arguments);
  }

  emit(eventName: string, data?: any, callback?: Function) {
    // return this.socket.emit.apply(this.socket, arguments);

  }

  removeListener(eventName: string, callback?: Function) {
    // return this.socket.removeListener.apply(this.socket, arguments);
  }

  loadQueuePayroll(data): any {
    // this.queueList = data;
    // this.queueSubject.next(this.queueList);
    // if (data.length <= 0) {
    //   this.baloonSubject.next(false)
    // }
  }

  // runSocketPayroll(nameEvent) {
  //   this.socket.removeListener()
  //   setTimeout(() => {
  //     this.socket.emit('room-join', nameEvent)
  //     this.socket.on('PayrollProcess', (data) => {
  //       if (this.queueList.length > 0) {
  //         const idx = this.queueList.findIndex(row => row.id == data.queueId);
  //         if (idx >= 0) {
  //           this.queueList[idx].tracks.push(data);
  //           this.queueSubject.next(this.queueList);
  //           this.countCurrent = this.queueList[idx].tracks.length;
  //         }
  //       }
  //     })
  //   }, 1000);
  // }

  showBaloon() {
    // if (this.queueList.length > 0) {
    //   if (this.queueList[0].tracks.length >= this.queueList[0].totalProcess) {
    //     this.baloonSubject.next(false)
    //   } else {
    //     this.baloonSubject.next(true)
    //   }
    // } else {
    //   this.baloonSubject.next(false)
    // }
  }

  getProcessingPayrollTmp() {
    // return this.processingPayrollTmp;
  }

  setProcessingPayrollTmp(val) {
    // this.processingPayrollTmp = val;
  }

}




// WEBPACK FOOTER //
// ./src/providers/socket-io-client/socket-io-client.ts